import { render, staticRenderFns } from "./borderBox.vue?vue&type=template&id=49f92340&scoped=true&"
var script = {}
import style0 from "./borderBox.vue?vue&type=style&index=0&id=49f92340&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f92340",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49f92340')) {
      api.createRecord('49f92340', component.options)
    } else {
      api.reload('49f92340', component.options)
    }
    module.hot.accept("./borderBox.vue?vue&type=template&id=49f92340&scoped=true&", function () {
      api.rerender('49f92340', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/borderBox.vue"
export default component.exports